/* global */
/*------------------------------------------------------------*/
import { version } from '../../package.json';
export const info = () => `sdk ${version}`;
/*------------------------------------------------------------*/
type InitParams = {
    svcWorker?: string,
    webNotify?: boolean,
    wakeLock?: boolean,
    btnToTop?: boolean,
    hideTabbar?: boolean,
};
export const init = (params?: InitParams) => {
    if (params?.svcWorker) svcWorker(params.svcWorker);
    if (params?.webNotify) webNotify();
    if (params?.wakeLock) wakeLock();
    if (params?.btnToTop) btnToTop();
    if (params?.hideTabbar) hideTabbar();
};
/*------------------------------------------------------------*/
const svcWorker = (worker: string) => {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker.register(worker, {
        type: 'module'
    }).catch(err => console.warn(err));
};
/*------------------------------------------------------------*/
const webNotify = () => {
    if (!('Notification' in window)) return;
    Notification.requestPermission()
        .catch(err => console.warn(err));
};
/*------------------------------------------------------------*/
const wakeLock = () => {
    if (document.hidden) return;
    navigator.wakeLock.request('screen')
        .catch(err => console.warn(err));
};
/*------------------------------------------------------------*/
const hideTabbar = () => {
    const winHeight = window.innerHeight;
    window.visualViewport?.addEventListener('resize', () => {
        const tabbar = document.querySelector<HTMLElement>('#tabbar');
        if (!tabbar) return;
        if (winHeight != window.innerHeight) {
            tabbar.classList.add('hide');
        } else {
            tabbar.classList.remove('hide');
        }
    });
};
/*------------------------------------------------------------*/
const app = document.querySelector<HTMLElement>('#app');
const btnToTop = () => {
    if (!app) return;
    // create item
    const totop = document.createElement('div');
    totop.id = 'totop';
    totop.innerHTML = /* html */ `
        <button id="btn-totop" class="circle purple" shadow="true"
            title="กลับด้านบน">&#xf341;</button>
    `;
    document.body.appendChild(totop);
    // add event
    totop.querySelector<HTMLButtonElement>('#btn-totop')!.onclick = () => {
        app.scrollTo({ top: 0, behavior: 'smooth' });
    };
    app.addEventListener('scroll', () => {
        if (app.scrollTop > 1000) {
            totop.style.display = 'block';
            if (app.classList.contains('tabbar')) {
                app.style.paddingBottom = '116px';
            } else {
                app.style.paddingBottom = '60px';
            }
        } else {
            totop.style.display = '';
            app.style.paddingBottom = '';
        }
        // tabs mobile shadow
        const tabsMobile = app.querySelector<HTMLElement>('.slim-tabs.mobile .tabs-header');
        if (!tabsMobile) return;
        if (app.scrollTop > 10) {
            tabsMobile.style.boxShadow = `rgba(0, 0, 0, 0.16) 0px 1px 4px`;
        } else {
            tabsMobile.style.boxShadow = '';
        }
    });
};
/*------------------------------------------------------------*/